import React from 'react'

const UserManagement = (props: any) => {
  return (
    <div>
      
    </div>
  )
}

export default UserManagement
